<template>
  <BasePopup
    :visible="visible"
    popupClass="audit-notices-popup"
    :showCloseBtn="true"
    closeBtnClass="popup-content-close"
    :maskClosable="true"
    @close="handleClose"
  >
    <template #title>
      <i class="popup-title-icon audit-icon"></i>
      <div class="popup-title-text audit-title"></div>
    </template>

    <div class="notices-content">
      <template v-if="notices && notices.length > 0">
        <div class="notice-item" v-for="(notice, index) in notices" :key="index">
          <div class="notice-text" v-html="formatNoticeText(notice)"></div>
          <div class="notice-reason">{{ reasonLabel }}{{ notice.reason }}</div>
          <div class="notice-time">{{ timeLabel }}{{ notice.noticeTime }}</div>
          <div class="notice-item-split" v-if="index !== notices.length - 1"></div>
        </div>
      </template>
      <div v-else class="empty-notices">
        <div class="empty-text">{{ emptyText || '暂无审核通知' }}</div>
      </div>
    </div>
  </BasePopup>
</template>

<script setup>
import BasePopup from './BasePopup.vue';

// Props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  notices: {
    type: Array,
    default: () => []
  },
  title: {
    type: String,
    default: '审核结果通知'
  },
  emptyText: {
    type: String,
    default: '暂无审核通知'
  },
  contentTemplate: {
    type: String,
    default: '您于 ${time} 提交的作品《${title}》'
  },
  reasonLabel: {
    type: String,
    default: '原因：'
  },
  timeLabel: {
    type: String,
    default: '通知时间：'
  }
});

// Emits
const emit = defineEmits(['close', 'update:visible']);

// 格式化通知文本
const formatNoticeText = (notice) => {
  return props.contentTemplate
    .replace(/\$\{time\}/g, notice.submitTime || '')
    .replace(/\$\{title\}/g, notice.title || '');
};

// 关闭弹窗
const handleClose = () => {
  emit('close');
  emit('update:visible', false);
};
</script>

